import {
    useState,
    isValidElement,
    ReactElement,
    ReactNode,
    useEffect,
} from 'react'

export const useInlineUpdateInsight = (
    headline: ReactNode,
    date_updated: Date
) => {
    const [variant, setVariant] = useState<string | null>(null)
    const [prevVariant, setPrevVariant] = useState<string | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [lastUpdated, setLastUpdated] = useState<Date>()

    useEffect(() => {
        if (Array.isArray(headline)) {
            headline.forEach((item) => {
                if (isValidElement(item)) {
                    const elementWithProps = item as ReactElement<{
                        value?: string
                    }>
                    setLastUpdated(date_updated)
                    const val = elementWithProps.props.value
                    if (val && val !== variant) {
                        setPrevVariant(variant)
                        setVariant(val)
                    }
                }
            })
        }
    }, [variant, headline, date_updated])

    useEffect(() => {
        if (prevVariant !== null && variant !== prevVariant) {
            setLoading(true)
        }
    }, [variant, prevVariant])

    useEffect(() => {
        if (!loading) return
        if (lastUpdated !== date_updated) setLoading(false)
    }, [loading, date_updated, lastUpdated])

    return {
        loading,
    }
}
